/**
 * Reads the current user from localStorage (key: "auth", shape: { user }).
 * Returns the user object or null.
 * Used by page components to check granular permissions without prop-drilling.
 */
export function useCurrentUser() {
  try {
    const raw = localStorage.getItem("auth");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.user ?? null;
  } catch {
    return null;
  }
}
